import React, { FC } from 'react';
import cls from 'classnames';
import { useBi, useEnvironment, WidgetProps } from '@wix/yoshi-flow-editor';

import { groupListLoaded } from '@wix/bi-logger-groups/v2';

import { COMPONENT } from 'settings/constants';

import { SocialGroupsApp } from 'common/components/SocialGroupsApp';

import { Fade } from 'wui/Fade';
import { Container } from 'wui/Container';

import type { IControllerProps } from 'controller/types';

import { LayoutRoot } from 'GroupsListWidget/Widget/Layout';

import classes from './styles.scss';

COMPONENT.name = 'SideBySideWidget';

const SideBySideWidget: FC<WidgetProps<IControllerProps>> = (props) => {
  const { isMobile } = useEnvironment();

  const bi = useBi();

  React.useEffect(() => {
    bi.report(
      groupListLoaded({
        layout_type: 'side_by_side_widget',
      }),
    );
  }, []);

  return (
    <SocialGroupsApp {...props}>
      <Container
        fluid={isMobile}
        padding={isMobile ? 'SP0' : 'SP5'}
        data-hook="SideBySide-wrapper"
        className={cls(classes.root, {
          [classes.mobile]: isMobile,
        })}
      >
        <Fade key="sidebyside-widget" timeout={500}>
          <LayoutRoot />
        </Fade>
      </Container>
    </SocialGroupsApp>
  );
};

SideBySideWidget.displayName = 'SideBySideWidget';

export default SideBySideWidget;
